module.exports = __webpack_public_path__ + "static/media/filter_icon.5640aab4.svg";